import { Container, Row, Col, Image } from 'react-bootstrap';
import {
    NonprofitsDonations,
    NonprofitsRight,
    NonprofitsTitle,
    NonprofitsLeft,
    NonprofitsWrapper,
    TextCol,
    NonprofitList,
    NonproFitText,
    NonprofitsItem,
    WriteReviewBottomForm,
    TopViewNominate,
} from './writeReviewStyle';

import Badge from '../../assests/images/badge-lg.webp';
import LatestNewsForm from "../../components/common/latestNewsForm";
import {
    Title,
    WriteReviewSection,
    ReviewText,
    ReviewSearch,
    ReviewSerchBox,
    ReviewRightSection,
    LeftQuote,
    RightQuote,
    RightBanner,
    BannerBlueWrapper,
    BannerBlueTitle,
    BannerBlueText,
    BadgeSmallText,
} from "../../components/common/commonSubBanner/commonSubBannerStyle";

import BadgeCheckBox from "../../components/common/badgeCheckBox";
import ReviewImage from "../../assests/images/top-banner-image/review-your-favorite-nonprofits.webp";
import QuoteIcon from "../../assests/images/quoteicon.svg";
import MetaComponent from "../../components/common/metaComponent";
import SearchBox from '../../components/common/searchBox/searchBox';

const Nominate = () => {
    return (
        <>
            <MetaComponent
                keywords=""
                description=""
                ogTitle="Nominate a Nonprofit"
                ogDescription=""
                ogUrl="https://www.toprated.greatnonprofits.org/nominate"
            />

            <>
                <TopViewNominate>
                    <WriteReviewSection className="nominate-banner-sec">
                        <Container className="cont-w">
                            <Row>
                                <Col lg={6} sm={12} md={12}>
                                    <Title className="write-review-text">Review Your Favorite Nonprofits</Title>
                                    <ReviewText>Help them receive a Top-Rated Award! </ReviewText>
                                    <ReviewText>You can help your favorite nonprofit meet its goals, reach and help more people, and get the attention it deserves! </ReviewText>
                                    <ReviewText>So what are you waiting for? Use the search bar below to find a nonprofit to review today! </ReviewText>
                                    <ReviewSearch>
                                        <ReviewSerchBox className="review-serch-box">

                                            <SearchBox />
                                        </ReviewSerchBox>
                                    </ReviewSearch>
                                    <BannerBlueWrapper className="blue-banner">
                                        <BannerBlueTitle>Contact GreatNonprofits</BannerBlueTitle>
                                        <BannerBlueText>Monday to Friday, 8am to 4pm PST</BannerBlueText>
                                    </BannerBlueWrapper>

                                    <BadgeSmallText className="base-small-text">Add a Logo Badge to Your Website</BadgeSmallText>
                                    <BadgeCheckBox setColor={() => { }} />
                                </Col>
                                <Col lg={6} sm={12} md={12}>
                                    <RightBanner className="left_banner">
                                        <ReviewRightSection>
                                            <LeftQuote className="quote_col"><span><Image src={QuoteIcon} alt="QuoteIcon" /></span> I've worked in nonprofits for over 20 years, and having this tool now is a first for me. I'm really grateful for it.</LeftQuote>
                                            <Image src={ReviewImage} alt="ReviewImage" />
                                            <RightQuote className="quote_col"><span><Image src={QuoteIcon} alt="QuoteIcon" /></span> I've worked in nonprofits for over 20 years, and having this tool now is a first for me. I'm really grateful for it.</RightQuote>
                                        </ReviewRightSection>
                                    </RightBanner>
                                </Col>
                            </Row>
                        </Container>
                    </WriteReviewSection>
                </TopViewNominate>

                <NonprofitsDonations>
                    <Container className="cont-w">
                        <NonprofitsWrapper>
                            <NonprofitsLeft>
                                <Image src={Badge} />
                            </NonprofitsLeft>
                            <NonprofitsRight>
                                <NonprofitsTitle>Want to help your favorite nonprofits get more donations?</NonprofitsTitle>
                                <TextCol>It's easy! All you have to do is write a new, positive review (4 or 5 stars) about your favorite nonprofit. You can also write new reviews for nonprofits you've rated previously. </TextCol>
                                <TextCol>By sharing your feedback, your favorite nonprofits can gain visibility, supporters and the opportunity to receive a 2024 Top-Rated Award.</TextCol>
                            </NonprofitsRight>
                        </NonprofitsWrapper>

                        <NonprofitList>
                            <NonprofitsItem>
                                <NonproFitText>Nonprofits that receive at least 10 new, positive ratings during the campaign period (January 1, 2024 to December 31, 2024) will be Top-Rated for the year.</NonproFitText>
                            </NonprofitsItem>
                            <NonprofitsItem>
                                <NonproFitText>Nonprofits will be showcased on the 2024 Top-Rated list.</NonproFitText>
                            </NonprofitsItem>
                            <NonprofitsItem>
                                <NonproFitText>We'll promote the Top-Rated list regularly from April 1 through December 31.</NonproFitText>
                            </NonprofitsItem>
                            <NonprofitsItem>
                                <NonproFitText>The 2024 Top-Rated list will be distributed to media and corporate foundations. Winning nonprofits will receive marketing tools to help them promote this honor.</NonproFitText>
                            </NonprofitsItem>
                        </NonprofitList>
                    </Container>
                </NonprofitsDonations>

                <WriteReviewBottomForm>
                    <Container className="cont-w">
                        <Row>
                            <Col sx="12">
                                <LatestNewsForm />
                            </Col>
                        </Row>
                    </Container>
                </WriteReviewBottomForm>
            </>
        </>

    )
};
export default Nominate;